import React, { useEffect, useState } from 'react';
import styles from './KoordinatSok.module.css';
import { HiSearch } from 'react-icons/hi';
import { Stack, TextField } from '@mui/material';
import { useKartstodContext } from './contexts/KartstodContext';
import ModalInfotext from './ModalInfotext';
import classNames from 'classnames';
import { Koordinater } from './model/KartstodModel';

interface KoordinatSokProps {
  koordinater: Koordinater;
  setKoordinater: (koordinater: Koordinater) => void;
  sokMedKoordinater: (n: number, e: number) => void;
}

type StringKoordinater = {
  nKoordinat: string;
  eKoordinat: string;
};

const KoordinatSok = (props: KoordinatSokProps) => {
  const {
    isSokKoordinaterOpen,
    setIsSokKoordinaterOpen,
    setIsRitverktygOpen,
    setIsInstallningarOpen,
    setVisaFelmeddelande,
    setFelmeddelande,
  } = useKartstodContext();
  const [stringKoordinater, setStringKoordinater] = useState<StringKoordinater>(
    { nKoordinat: '', eKoordinat: '' }
  );
  const [visaHR, setVisaHR] = useState(false);

  useEffect(() => {
    const northing = Math.round(props.koordinater.nKoordinat).toString();
    const easting = Math.round(props.koordinater.eKoordinat).toString();

    if (northing === '0' || easting === '0') {
      setStringKoordinater({ nKoordinat: '', eKoordinat: '' });
    } else {
      setStringKoordinater({ nKoordinat: northing, eKoordinat: easting });
    }
  }, [props.koordinater]);

  const valideraCoords = (coordinate: string, length: number) => {
    const isNum = /^\d+$/.test(coordinate);
    if (isNum === false) {
      setFelmeddelande('Koordinater kan enbart innehålla siffror.');
      setVisaFelmeddelande(true);
      return true;
    } else if (coordinate.length !== length) {
      setFelmeddelande('Felaktig längd på koordinater.');
      setVisaFelmeddelande(true);
      return true;
    }

    if (length === 7) {
      if (parseInt(coordinate) > 7671270 || parseInt(coordinate) < 6110548) {
        setFelmeddelande('Koordinater ligger utanför Sveriges gräns.');
        setVisaFelmeddelande(true);
        return true;
      }
    }
    if (length === 6) {
      if (parseInt(coordinate) > 921472 || parseInt(coordinate) < 245312) {
        setFelmeddelande('Koordinater ligger utanför Sveriges gräns.');
        setVisaFelmeddelande(true);
        return true;
      }
    }

    setVisaFelmeddelande(false);
    return false;
  };

  const sokCoords = () => {
    if (valideraCoords(stringKoordinater.nKoordinat, 7)) {
      return false;
    } else if (valideraCoords(stringKoordinater.eKoordinat, 6)) {
      return false;
    }

    props.setKoordinater({
      nKoordinat: parseInt(stringKoordinater.nKoordinat),
      eKoordinat: parseInt(stringKoordinater.eKoordinat),
    });
    props.sokMedKoordinater(
      parseInt(stringKoordinater.nKoordinat),
      parseInt(stringKoordinater.eKoordinat)
    );
  };

  const togglaKoordinatSok = () => {
    setIsSokKoordinaterOpen(!isSokKoordinaterOpen);
    setIsRitverktygOpen(false);
    setIsInstallningarOpen(false);
  };

  const visaHjalpRuta = () => {
    isSokKoordinaterOpen ? setVisaHR(false) : setVisaHR(true);
  };

  const doljHjalpRuta = () => {
    setVisaHR(false);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      sokCoords();
    }
  };

  return (
    <div className={styles.koordinatSokContainer}>
      {visaHR ? (
        <ModalInfotext
          meddelande={'Sök med koordinater'}
          style={{ top: '5px', width: '113px' }}
        />
      ) : null}
      <div
        className={classNames(
          styles.koordinatSokWrapper,
          isSokKoordinaterOpen
            ? styles.koordinatSokWrapperActive
            : styles.shrinkIcon
        )}
      >
        <div
          className={styles.searchTool}
          onClick={togglaKoordinatSok}
          onMouseEnter={visaHjalpRuta}
          onMouseLeave={doljHjalpRuta}
        >
          <HiSearch size="25" />
        </div>
        <div className={styles.sokBoxContainer}>
          <div className={styles.swerefContainer}>SWEREF 99 TM</div>
          <Stack direction={'row'} sx={{ pr: 2 }}>
            <TextField
              label="N"
              size="small"
              variant="outlined"
              sx={{
                m: 0,
                paddingRight: '5px',
                width: '120px',
                color: 'grey',
              }}
              value={stringKoordinater.nKoordinat}
              onChange={(event) =>
                setStringKoordinater({
                  ...stringKoordinater,
                  nKoordinat: event.target.value,
                })
              }
              onKeyDown={(event) => handleKeyDown(event)}
            />
            <TextField
              label="E"
              size="small"
              sx={{
                m: 0,
                paddingRight: '5px',
                width: '120px',
                color: 'grey',
              }}
              variant="outlined"
              value={stringKoordinater.eKoordinat}
              onChange={(event) =>
                setStringKoordinater({
                  ...stringKoordinater,
                  eKoordinat: event.target.value,
                })
              }
              onKeyDown={(event) => handleKeyDown(event)}
            />
            <div className={styles.submitWrapper} onClick={sokCoords}>
              <HiSearch size="25" />
            </div>
          </Stack>
        </div>
      </div>
    </div>
  );
};

export default KoordinatSok;
